.<template>
  <div>
    <v-expand-x-transition>
      <landing-toolbar />
    </v-expand-x-transition>
    <Groups />
  </div>
</template>
  
  <script>
import LandingToolbar from "../../components/LandingToolbar/LandingToolbar.vue";
import Groups from "../../components/GestionEmpleados/Views/Employee/Groups.vue";
export default {
  components: { LandingToolbar, Groups },
};
</script>